import { render, staticRenderFns } from "./chooseAddress.vue?vue&type=template&id=57b222ab&scoped=true&"
import script from "./chooseAddress.vue?vue&type=script&lang=js&"
export * from "./chooseAddress.vue?vue&type=script&lang=js&"
import style0 from "./chooseAddress.vue?vue&type=style&index=0&id=57b222ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b222ab",
  null
  
)

export default component.exports